// Reviewed against Pencil's 多语言文案表（2026-09-15）, node Ihk4M.
// Numbers and names in the design are examples, not fixed account data.
export interface PencilCopyEntry {
  row: number
  keys: string[]
  replacements?: [string, string][]
  trimArrow?: boolean
  summary?: boolean
}

export const pencilCopyContract: PencilCopyEntry[] = [
  { row: 1, keys: ['enterprise_management_international'] },
  { row: 3, keys: ['account_menu_home'] },
  { row: 4, keys: ['product_content_tab_title2', 'product_content_tab_title_2'] },
  { row: 5, keys: ['account_enterprise_manager', 'account_menu_enterprise'] },
  { row: 6, keys: ['account_to_route_title2', 'account_menu_translate'] },
  { row: 7, keys: ['account_to_route_title3', 'account_enterprise_cost_record', 'account_menu_cost'] },
  { row: 8, keys: ['account_enterprise_add_member_art', 'account_menu_art', 'enterprise_management_terms'] },
  { row: 9, keys: ['account_enterprise_order', 'account_menu_orders'] },
  { row: 10, keys: ['account_menu_combo'] },
  { row: 11, keys: ['enterprise_ui_used_quota'], replacements: [['1,545,807', '{used}'], ['10,000,000', '{total}']] },
  { row: 13, keys: ['enterprise_ui_enterprise_title'], replacements: [['Doclingo', '{name}']] },
  { row: 14, keys: ['enterprise_ui_global_enterprise_title'], replacements: [['Doclingo', '{name}']] },
  { row: 15, keys: ['account_enterprise_add_member'] },
  { row: 16, keys: ['account_enterprise_dissolve_title'] },
  { row: 17, keys: ['combo_info', 'enterprise_management_plan_info'] },
  { row: 18, keys: ['enterprise_ui_seats_ai'], replacements: [['3 / 10', '{used} / {total}']] },
  { row: 19, keys: ['enterprise_ui_seats_vip'], replacements: [['3 / 10', '{used} / {total}']] },
  { row: 20, keys: ['enterprise_ui_seats_global'], replacements: [['8 / 10', '{used} / {total}']] },
  { row: 21, keys: ['enterprise_management_plan_quota'] },
  { row: 22, keys: ['enterprise_ui_site_ai'] },
  { row: 23, keys: ['enterprise_ui_site_vip'] },
  { row: 24, keys: ['enterprise_management_remaining_chars_value'], replacements: [['4,704,193', '{count}']] },
  { row: 26, keys: ['enterprise_management_alert_settings'], trimArrow: true },
  { row: 27, keys: ['enterprise_management_fuel_quota', 'pro_dialog_tab_title_fuel'] },
  { row: 28, keys: ['enterprise_management_fuel_validity', 'enterprise_management_fuel_validity_hint'] },
  { row: 29, keys: ['enterprise_management_buy_fuel'], trimArrow: true },
  { row: 30, keys: ['enterprise_management_china_pool'] },
  { row: 31, keys: ['enterprise_management_international_pool'] },
  { row: 32, keys: ['enterprise_management_fuel_remaining_value'], replacements: [['0', '{count}']] },
  { row: 33, keys: ['account_enterprise_table_header_alias', 'enterprise_management_alias'] },
  { row: 34, keys: ['account_enterprise_table_header_status', 'enterprise_management_status'] },
  { row: 35, keys: ['account_enterprise_table_header_join_time'] },
  { row: 36, keys: ['account_enterprise_table_header_permission', 'enterprise_management_permissions'] },
  { row: 37, keys: ['account_enterprise_table_header_operation', 'enterprise_management_operations', 'art_table_title6'] },
  { row: 38, keys: ['enterprise_management_workspace'] },
  { row: 39, keys: ['create_enterprise_table_header_creator'] },
  { row: 40, keys: ['enterprise_management_china'] },
  { row: 41, keys: ['account_enterprise_table_header_status_success'] },
  { row: 42, keys: ['enterprise_management_pending', 'account_enterprise_table_header_status_ing'] },
  { row: 43, keys: ['enterprise_management_expired'] },
  { row: 44, keys: ['enterprise_management_invited_at'], replacements: [['2026-08-27', '{time}']] },
  { row: 46, keys: ['enterprise_management_expired_at'], replacements: [['2026-09-12', '{time}']] },
  { row: 47, keys: ['account_enterprise_table_header_file_permission'] },
  { row: 48, keys: ['account_enterprise_table_header_art_permission'] },
  { row: 49, keys: ['account_enterprise_permission_look'] },
  { row: 50, keys: ['account_enterprise_permission_download'] },
  { row: 51, keys: ['account_enterprise_permission_term_use', 'account_enterprise_add_member_permission_use'] },
  { row: 52, keys: ['account_enterprise_permission_edit', 'art_edit'] },
  { row: 53, keys: ['enterprise_management_edit_member'] },
  { row: 54, keys: ['enterprise_management_remove_record'] },
  { row: 55, keys: ['enterprise_management_revoke'] },
  { row: 56, keys: ['enterprise_management_readd'] },
  { row: 57, keys: ['enterprise_ui_member_summary'], replacements: [['3', '{count}'], ['1', '{expired}']] },
  { row: 58, keys: ['enterprise_ui_member_page_summary'], replacements: [['8', '{count}'], ['5', '{pageSize}'], ['1 / 2', '{page} / {total}']] },
  { row: 59, keys: ['enterprise_management_email_add'] },
  { row: 60, keys: ['enterprise_management_link_invite'] },
  // 0918 设计已将“所属空间”统一为更短的工作区标签，不再受 0915 文案表约束。
  { row: 62, keys: ['enterprise_management_international_workspace'] },
  { row: 63, keys: ['enterprise_management_china_workspace'] },
  { row: 64, keys: ['enterprise_management_single_workspace_hint'] },
  { row: 65, keys: ['enterprise_management_multi_workspace_hint'] },
  { row: 66, keys: ['enterprise_ui_email_label'] },
  { row: 67, keys: ['enterprise_ui_alias_label'] },
  { row: 68, keys: ['enterprise_ui_role_label'] },
  // 0918 权限说明采用新版短标签，不再受 0915 文案表约束。
  { row: 70, keys: ['enterprise_management_files', 'account_enterprise_add_member_file'] },
  { row: 71, keys: ['account_enterprise_add_member_permission_viewer'] },
  { row: 72, keys: ['enterprise_management_email_not_registered'] },
  { row: 73, keys: ['enterprise_management_switch_link_invite'], trimArrow: true },
  { row: 74, keys: ['enterprise_management_email_add_rule_single'] },
  { row: 75, keys: ['enterprise_management_email_add_rule_global'] },
  { row: 76, keys: ['enterprise_management_confirm_add'] },
  // 0918 邀请流程增加权限设置语义，单区说明不再使用 0915 的旧描述。
  // 0918 邀请流程增加权限设置语义，全球版说明不再使用 0915 的旧描述。
  { row: 79, keys: ['enterprise_management_generate_link'] },
  { row: 80, keys: ['enterprise_management_copy'] },
  { row: 81, keys: ['enterprise_ui_link_validity'], replacements: [['2026-09-21 13:33', '{time}'], ['5', '{days}'], ['20', '{hours}']] },
  { row: 82, keys: ['enterprise_management_regenerate_link'] },
  // 0918 将权限绑定到邀请链接，单区与全球版注意事项均由新版流程定义。
  { row: 85, keys: ['enterprise_management_copy_and_close'] },
  { row: 86, keys: ['enterprise_ui_expired_invite_title'] },
  { row: 87, keys: ['enterprise_ui_expired_invite_heading'] },
  { row: 88, keys: ['enterprise_ui_expired_invite_description'], replacements: [['2026-09-12 13:33', '{time}']] },
  { row: 89, keys: ['enterprise_ui_regenerate_invite'] },
  { row: 90, keys: ['art_title', 'account_to_route_title4'] },
  { row: 91, keys: ['art_library_title_tip'] },
  { row: 92, keys: ['art_search'] },
  { row: 93, keys: ['art_more'] },
  { row: 94, keys: ['art_create_title'] },
  { row: 95, keys: ['art_table_title1'] },
  { row: 96, keys: ['art_table_title2'] },
  { row: 97, keys: ['art_table_title4'] },
  { row: 98, keys: ['art_table_title3'] },
  { row: 99, keys: ['art_file_reset_name'] },
  { row: 100, keys: ['art_delete', 'art_selected_delete', 'account_enterprise_operation_delete'] },
  { row: 101, keys: ['art_official_tag'] },
  { row: 102, keys: ['art_total_count'], replacements: [['3', '*']] },
  { row: 104, keys: ['art_new_manual_title'] },
  { row: 105, keys: ['art_new_excel_title'] },
  { row: 106, keys: ['art_new_excel_tip'] },
  { row: 107, keys: ['art_new_official_title'] },
  { row: 108, keys: ['art_new_official_tip_business'] },
  { row: 109, keys: ['art_selected_count'], replacements: [['2', '*']] },
  { row: 110, keys: ['art_selected_export'] },
  { row: 111, keys: ['art_selected_cancel'] },
  { row: 112, keys: ['art_batch_export'] },
  { row: 113, keys: ['art_more_export_tip'] },
  { row: 114, keys: ['art_batch_import'] },
  { row: 115, keys: ['art_more_import_tip'] },
  { row: 116, keys: ['art_more_template_title'] },
  { row: 117, keys: ['art_more_template_tip'] },
  { row: 133, keys: ['account_logout'] },
  { row: 139, keys: ['product_content_tab_title1', 'product_content_tab_title_1'] },
  { row: 148, keys: ['art_preset_title'] },
  // 2026-09-25 更新为官方术语库按语言对导入的新文案。
  { row: 149, keys: ['art_preset_desc_business', 'art_preset_tip'] },
  { row: 150, keys: ['art_preset_select_all'] },
  { row: 151, keys: ['art_preset_imported'] },
  { row: 152, keys: ['art_preset_preview_title'] },
  { row: 153, keys: ['art_preset_preview_empty'] },
  { row: 154, keys: ['accountLoginOutBtn1', 'cancel'] },
  { row: 155, keys: ['art_preset_import_btn'], replacements: [['0', '*']] },
  { row: 157, keys: ['art_preset_preview_summary'], replacements: [['113', '{count}']], summary: true },
  // 2026-09-25 更新为官方术语库按语言对导入的新文案。
  { row: 158, keys: ['art_preset_source_column'] },
  { row: 159, keys: ['art_preset_translation_column'] },
  { row: 160, keys: ['art_preset_reimport_tip'] },
]

export function preparePencilCopy(value: string, entry: PencilCopyEntry): string {
  let result = entry.summary ? value.replace(/^[^·]+(?=·)/, '{name} ') : value
  for (const [sample, parameter] of entry.replacements || []) {
    // French/Ukrainian use spaces and German/Italian/Indonesian use dots
    // for the same example number. Never retain a design account's quota.
    if (/^\d{1,3}(,\d{3})+$/.test(sample)) {
      result = result.replace(new RegExp(sample.split(',').join('[,.\\s\\u202F\\u00A0]')), parameter)
    } else {
      result = result.replace(sample, parameter)
      // Arabic spells out the single expired invitation in the design sample.
      if (entry.row === 57 && parameter === '{expired}') result = result.replace('واحدة', parameter)
    }
  }
  return entry.trimArrow ? result.replace(/\s*→$/, '') : result
}

const protectedKeys = new Set(pencilCopyContract.flatMap(entry => entry.keys))
for (const key of ['art_dialog_row_user_tip', 'art_dialog_create_max_user_tip', 'upload-item-part-success', 'art_library_title_tip1', 'art_library_title_tip2', 'art_library_title_tip3', 'art_library_title_tip4', 'art_library_title_please_tip4', 'art_library_title_tip5', 'art_library_title_tip6', 'art_library_title_tip7']) protectedKeys.add(key)
export function isLocalEnterpriseCopy(key: string): boolean {
  return protectedKeys.has(key) || key.startsWith('enterprise_ui_') || key.startsWith('enterprise_management_')
}
